import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Link } from 'react-router-dom';

import { scrollTo, isMobileUA } from 'dpl/shared/utils';
import SmartImage from 'dpl/components/SmartImage';
import HorizontalSlider from 'dpl/components/HorizontalSlider';
import { sendRudderstackEvent } from 'dpl/util/analytics';
import {
  ANALYTICS_EVENTS,
  ANALYTICS_VIEWS,
  ANALYTICS_VIEW_FEATURES
} from 'dpl/constants/analytics';

const IS_MOBILE = isMobileUA();

function ExploreBreedCategoryLink({ breedCategory, isSelected, onClick }) {
  return (
    <Link
      to={`/explore/${breedCategory.slug}`}
      onClick={onClick}
      className={classnames('f0 ba bw1 card db relative', {
        'b--transparent': !isSelected,
        'b--blue-500 bg-blue-500': isSelected,
        white: isSelected || IS_MOBILE
      })}
    >
      <SmartImage
        lazy
        src={breedCategory.cover_photo_url}
        width="156px"
        height="156px"
        className="bg-white"
      />
      <p
        className={classnames(
          'f2 pv2 ph2 fw-medium nowrap truncate min-w-100 w0',
          {
            'text-shadow absolute bottom-0': IS_MOBILE
          }
        )}
      >
        {breedCategory.name}
      </p>
    </Link>
  );
}

ExploreBreedCategoryLink.propTypes = {
  breedCategory: PropTypes.shape({
    slug: PropTypes.string.isRequired,
    cover_photo_url: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  }).isRequired,
  isSelected: PropTypes.bool.isRequired,
  onClick: PropTypes.func
};

ExploreBreedCategoryLink.defaultProps = {
  onClick: null
};

export default function ExploreBreedCategories({
  categories,
  selectedSlug,
  hideArrows
}) {
  if (categories.length === 0) {
    return null;
  }

  function onCategoryLinkClick(category) {
    sendRudderstackEvent(ANALYTICS_EVENTS.BUTTON_CLICKED, {
      button_cta: category.name,
      view: ANALYTICS_VIEWS.EXPLORE_PAGE,
      view_feature: ANALYTICS_VIEW_FEATURES.EXPLORE_PAGE_CATEGORY
    });
    scrollTo({ top: 0, behavior: 'smooth' });
  }

  return (
    <div className="ExploreBreedCategories">
      <HorizontalSlider
        iconClassName="b bg-white ph3 pv3 br-100 box-shadow-strong"
        arrowClassName={classnames('pb1', {
          dn: hideArrows
        })}
        persistentArrows
        containerClassName="row flex-nowrap pb4-md pt6-md pt2 pb2 slim-gutters-mobile"
      >
        {categories.map(c => (
          <div className="col-auto" key={c.id}>
            <ExploreBreedCategoryLink
              breedCategory={c}
              onClick={() => onCategoryLinkClick(c)}
              isSelected={c.slug === selectedSlug}
            />
          </div>
        ))}
      </HorizontalSlider>
    </div>
  );
}

ExploreBreedCategories.propTypes = {
  hideArrows: PropTypes.bool,
  selectedSlug: PropTypes.string,
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired
    })
  ).isRequired
};

ExploreBreedCategories.defaultProps = {
  hideArrows: false,
  selectedSlug: null
};
